import React from 'react';
import PropTypes from 'prop-types';
import { Spacer } from '@tfecom-thermofisher/react-komodo-design';

import { Modal, Button } from 'src/core/components';
import messages from 'src/components/OligoDNA/messages';
import EmailForm from 'src/components/OligoDNA/components/EmailForm';

const EmailComponent = ({
  isOpen,
  openModal,
  handleClose,
  onSuccess,
  handleShareOrder
}) => (
  <>
    <Button
      type="primary"
      label={messages.email}
      onClick={openModal}
    />
    <Spacer bottom={10} />
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title={messages.emailModalTitle}
      id="add-email-modal-id"
      noActions
      content={(
        <EmailForm
          onSuccess={onSuccess}
          handleShareOrder={handleShareOrder}
        />
      )}
    />
  </>
);

EmailComponent.propTypes = {
  isOpen: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  handleShareOrder: PropTypes.func.isRequired
};

export default EmailComponent;
